import { v4 as uuidv4 } from 'uuid';
import ModalForm from "../components/forms/modal-form";
import NetworkService from "../services/network-service";
import {AnalyticsService} from "../services/analytics-service";
import ServiceLocator from "../services/service-locator";
import EnvHelper from "../helpers/env-helper";

export default class ConsultationForm {
    constructor() {
        this.$triggers = document.querySelectorAll('[data-modal-trigger="consultation"]');
        this.sl = ServiceLocator.instance;
        this.init();
    }

    sendAnalyticsEvent(eventName, data = {}) {
        const eventData = { ...data };

        switch (EnvHelper.page.handle) {
            case 'course-entry':
                Object.assign(eventData, {
                    training_type: 'Course'
                });

                if (EnvHelper.page.title) {
                    Object.assign(eventData, {
                        training_name: EnvHelper.page.title
                    });
                }
                break;
            case 'webinar-entry':
                Object.assign(eventData, {
                    training_type: 'Webinar'
                });

                if (EnvHelper.page.title) {
                    Object.assign(eventData, {
                        training_name: EnvHelper.page.title
                    });
                }
                break;
        }

        AnalyticsService.sendEvent(eventName, eventData);
    }

    init() {
        let buttonLabel = null;

        this.consultationForm = new ModalForm({
            formId: 'consultation',
            uri: '/2.0/courses/registration',
            hash: 'consultation',
            data: {
                type: 'consultation',
                branding: 'bookford',
                fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
                fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
                referrer: location.href
            },
            $modalTriggers: Array.from(this.$triggers),
            beforeOpen: ($trigger) => {
                if ($trigger) {
                    buttonLabel = $trigger.textContent;
                }

                this.sendAnalyticsEvent('form_start');
            },
            beforeClose: () => {
                buttonLabel = null;
            },
            subscriptions: [
                {
                    field: 'course',
                    event: 'getEntryIdOnValueChange',
                    callback: ({ detail }) => {
                        /* FB Analytics */
                        NetworkService.sendFbEvent('AddToCart', {
                            entryId: detail
                        });
                    }
                },
                {
                    event: 'beforeSubmit',
                    callback: () => {
                        const courseLang = this.sl.courseLang;
                        const conversionId = uuidv4();
                        const owoxUserId = costorage.get('ouid');


                        if (courseLang) {
                            this.consultationForm.addData({ courseLang });
                        }

                        this.consultationForm.addData({ conversionId });

                        if (owoxUserId) {
                            this.consultationForm.addData({ owoxUserId });
                        }

                        if (craft.page.courseDirectoryId) {
                            this.consultationForm.addData({ course: craft.page.courseDirectoryId });
                        }

                        if (buttonLabel) {
                            this.consultationForm.addData({ refButtonLabel: buttonLabel });
                        }

                        const eventData = {};

                        if (this.consultationForm.data.messenger) {
                            eventData.messenger = this.consultationForm.data.messenger;
                        }

                        this.sendAnalyticsEvent('form_submit', eventData);
                    }
                },
                {
                    event: 'submitComplete',
                    callback: () => {
                        costorage.set('h_consultationRequested', 1, {
                            expires: 45 * 24 * 60 * 60,
                            domain: '.bookford.com',
                            path: "/"
                        });
                    }
                }
            ]
        });
    }
}